import React from 'react';
import {
  TextFields as TextFieldsIcon,
  RadioButtonChecked as RadioIcon,
  CheckBox as CheckboxIcon,
  ArrowDropDownCircle as DropdownIcon,
  CalendarMonth as DateIcon,
  QuestionMark as QuestionMarkIcon,
  Schedule as TimeIcon,
  CloudUpload as UploadIcon,
  FormatListNumbered as ScaleIcon,
  LinearScale as SliderIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Subject as SubjectIcon
} from '@mui/icons-material';
import { QuestionType } from '@/types/questionTypes';

export const questionTypeDetails: {
  type: QuestionType;
  icon: React.ReactElement;
  label: string;
}[] = [
  {
    type: QuestionType.ShortText,
    icon: React.createElement(TextFieldsIcon),
    label: 'Short Text'
  },
  {
    type: QuestionType.Paragraph,
    icon: React.createElement(SubjectIcon),
    label: 'Paragraph'
  },
  {
    type: QuestionType.Checkbox,
    icon: React.createElement(CheckboxIcon),
    label: 'Multiple Choice (Checkbox)'
  },
  {
    type: QuestionType.Radio,
    icon: React.createElement(RadioIcon),
    label: 'Single Choice (Radio)'
  },
  {
    type: QuestionType.Dropdown,
    icon: React.createElement(DropdownIcon),
    label: 'Dropdown'
  },
  {
    type: QuestionType.Date,
    icon: React.createElement(DateIcon),
    label: 'Date'
  },
  {
    type: QuestionType.Time,
    icon: React.createElement(TimeIcon),
    label: 'Time'
  },
  {
    type: QuestionType.Email,
    icon: React.createElement(EmailIcon),
    label: 'Email'
  },
  {
    type: QuestionType.Phone,
    icon: React.createElement(PhoneIcon),
    label: 'Phone'
  },
  {
    type: QuestionType.FileUpload,
    icon: React.createElement(UploadIcon),
    label: 'File Upload'
  },
  {
    type: QuestionType.RatingScale,
    icon: React.createElement(ScaleIcon),
    label: 'Rating Scale'
  },
  {
    type: QuestionType.Slider,
    icon: React.createElement(SliderIcon),
    label: 'Slider'
  }
];

export const getTypeIcon = (type: QuestionType): React.ReactElement => {
  return (
    questionTypeDetails.find((qt) => qt.type === type)?.icon ||
    React.createElement(QuestionMarkIcon)
  );
};

export const getTypeLabel = (type: QuestionType): string => {
  return (
    questionTypeDetails.find((qt) => qt.type === type)?.label || 'Unknown Type'
  );
};
